export default __webpack_public_path__ + "static/media/auth.709fd2e4.jpg";